import { render, staticRenderFns } from "./RecentLabelTags.ts.vue?vue&type=template&id=0556e849&"
import script from "./RecentLabelTags.ts.vue?vue&type=script&lang=ts&"
export * from "./RecentLabelTags.ts.vue?vue&type=script&lang=ts&"
import style0 from "./RecentLabelTags.ts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VListItem})


/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0556e849')) {
      api.createRecord('0556e849', component.options)
    } else {
      api.reload('0556e849', component.options)
    }
    module.hot.accept("./RecentLabelTags.ts.vue?vue&type=template&id=0556e849&", function () {
      api.rerender('0556e849', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/labelTagging/RecentLabelTags.ts.vue"
export default component.exports